export function buildDefaultOpenSections({
  hasRsvpBlock,
  hasTicketBlock,
  hasCommentsBlock,
  rsvpNeedsResponse,
  rolesAutoOpen,
  outingAutoOpen,
  commentsAutoOpen,
  focusComments,
}) {
  const next = {
    roles: false,
    outing: false,
    rsvp: false,
    tickets: false,
    comments: false,
  };

  if (hasTicketBlock) {
    next.tickets = true;
  } else if (hasRsvpBlock && rsvpNeedsResponse) {
    next.rsvp = true;
  } else if (rolesAutoOpen) {
    next.roles = true;
  } else if (outingAutoOpen) {
    next.outing = true;
  }

  if ((focusComments || commentsAutoOpen) && hasCommentsBlock) {
    next.comments = true;
  }

  return next;
}

export function isRecurringRsvpEvent(form) {
  const hasRecurringRule =
    form.type === 'recurring' ||
    (Array.isArray(form.recurrence?.byDay) && form.recurrence.byDay.length > 0);
  const hasExplicitOccurrenceOverride =
    (form.scope === 'occurrence' || form.isOccurrenceOverride === true) &&
    Boolean(form.originalEventId) &&
    Boolean(form.occurrenceId);

  return hasRecurringRule || hasExplicitOccurrenceOverride;
}

export function rsvpNeedsResponse({
  hasRsvpBlock,
  isRecurringRsvp,
  myRsvpStatus,
  myRsvpOccurrenceStatus,
  myRsvpSeriesStatus,
  rsvpSeriesResponsesEnabled = true,
}) {
  if (!hasRsvpBlock) return false;
  if (isRecurringRsvp) {
    if (rsvpSeriesResponsesEnabled === false) return myRsvpOccurrenceStatus == null;
    return myRsvpOccurrenceStatus == null && myRsvpSeriesStatus == null;
  }
  return myRsvpStatus == null;
}
